import React from 'react'
import { useRecoilValue } from 'recoil'
import { UserAtom } from '../../../State/user.Atom'
import { UserManagement } from './UserManagement';
import { useRouteMatch } from '../../../Helpers/RouteMatcher';
import { Redirect, Route, Switch } from 'react-router-dom';
import { SimpleTab } from '../../../Component/Common/Components/Tabs/SimpleTab';
import { isNullOrEmpty } from '../../../Component/Model/helpers';
import { ClientAdvisors } from './Advisors/ClientAdvisors';
import config from '../../../config';

export const UserManagementBase = () => {
    const user = useRecoilValue(UserAtom);
    const routes = [
        `/userManagement/verificationAgencyUsers`,
        `/userManagement/clientUsers`
    ];
    const advisorRoutes = [
        `/userManagement/users`,
        `/userManagement/advisors`
    ]
    const labels = ['VA Users', 'Client Users'];
    const advisorLabels = ['Users', 'BEE123'];

    const tabsData = routes.map((route, index) => ({
        route,
        label: labels[index]
    }));

    const advisorTabsData = advisorRoutes.map((route, index) => ({
        route,
        label: advisorLabels[index]
    }));

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;
    const currentTabIndex = routes.findIndex(route => route === currentTab);

    const advisorRouteMatch = useRouteMatch(advisorRoutes);
    const advisorCurrentTab = advisorRouteMatch?.path;
    const advisorCurrentTabIndex = advisorRoutes.findIndex(route => route === advisorCurrentTab);

    const handleRedirect = () => {
        if (currentTabIndex === -1) {
            return <Redirect to={routes[0]} />;
        }
        return null;
    };

    const handleAdvisorRedirect = () => {
        if (advisorCurrentTabIndex === -1) {
            return <Redirect to={advisorRoutes[0]} />;
        }
        return null;
    };

    if (isNullOrEmpty(user.registrationId)) {
        return null;
    }

    if (user.isScorecardAdmin) {
        return (
            <>
                <UserManagement onlyClientUser={true} key={currentTab} />
            </>
        );
    }
    else if (user.hasAuditRole) {
        return (
            <>
                <SimpleTab currentTab={currentTab} tabsData={tabsData} />
                <Switch>
                    {handleRedirect()}
                    <Route path={routes[0]}>
                        <UserManagement ignoreClientUser={true} key={currentTab} />
                    </Route>
                    <Route path={routes[1]}>
                        <UserManagement onlyClientUser={true} key={currentTab} />
                    </Route>
                </Switch>
            </>
        );
    }
    else if (user.registrationId.toLocaleLowerCase() === config.advisory_registration_id.toLocaleLowerCase()) {
        return (
            <>
                <UserManagement />
            </>
        )
    }
    else if (user.isAdmin) {
        return (
            <>
                <SimpleTab currentTab={advisorCurrentTab} tabsData={advisorTabsData} />
                <Switch>
                    {handleAdvisorRedirect()}
                    <Route path={advisorRoutes[0]}>
                        <UserManagement key={advisorCurrentTab} />
                    </Route>
                    <Route path={advisorRoutes[1]}>
                        <ClientAdvisors key={advisorCurrentTab} />
                    </Route>
                </Switch>
            </>
        );
    }
    return (
        <>
            <UserManagement />
        </>
    )
}
